import React, { useEffect, Fragment } from 'react'
import Spinner from '../layout/Spinner'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Repos from '../repos/Repos'

const User = ({ user, match, getUser, getUserRepos, loading, repos}) => {

    useEffect(() => {
        getUser(match.params.login)
        getUserRepos(match.params.login)
        //eslint-disable-next-line
    },[])
    // componentDidMount (){
    //     getUser(match.params.login)
    //     getUserRepos(match.params.login)
    // }

        const {login, avatar_url, html_url, public_repos, following, public_gists, followers, company, blog,  location, bio, hireable, name} = user
        if (loading) return <Spinner />
        return (
            <Fragment>
                < Link to='/' className='btn btn-light'>
                    Back To Search
                </Link>
                Hireable : {'  '}
                {hireable ? <i className='fas fa-check text-success'/> : <i className='fas fa-times-circle text-danger'/>}
                <div className='card grid-2'>
                    <div className='all-center'>
                        <img src={avatar_url} className='round-img' alt='' style={{ width:'150px'}} />
                        <h1>{name}</h1>
                        <p>Location : {location}</p>
                    </div>
                    <div>
                        {bio && <Fragment>
                            <h3>Bio : </h3> 
                            <p>{bio}</p>
                            </Fragment>}
                        <a href={html_url} className='btn btn-dark my-1'>Visit Github Profile</a>
                        <ul>
                            <li>
                                {login && <Fragment>
                                    Username : {login}
                                    </Fragment>}
                            </li>
                            <li>
                                {company && <Fragment>
                                    Company : {company}
                                    </Fragment>}
                            </li>
                            <li>
                                {blog && <Fragment>
                                    Website : {blog}
                                    </Fragment>}
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='card text-center'>
                                <div className='badge badge-primary'>Followers: {followers}</div>
                                <div className='badge badge-success'>Following: {following}</div>
                                <div className='badge badge-light'>Public Repose: {public_repos}</div>
                                <div className='badge badge-dark'>Public Gists: {public_gists}</div>
                </div>
                <Repos repos={repos}/> 
            </Fragment>
        )
    }

User.propTypes = {
    loading : PropTypes.bool,
    user : PropTypes.object.isRequired,
    getUser : PropTypes.func.isRequired,
    getUserRepos : PropTypes.func.isRequired,
    repos : PropTypes.array.isRequired,
}

export default User
